<template>
  <!-- Arrest Banner -->
  <div v-if="redModel.arrest_model" class="info-banner__arrest">
    <InfoBanner :title="redModel.arrest_model.arrest_text">
      <template #action>
        <ChipButton
          @click="$redirect(redModel.arrest_model.arrest_button_link, 'push')"
          color="white"
        >
          {{ redModel.arrest_model.arrest_button_text }}
        </ChipButton>
      </template>
    </InfoBanner>
  </div>
  <!-- Overdue Banner -->
  <div v-if="redModel.overdue_model" class="info-banner__overdue">
    <InfoBanner
      :title="redModel.overdue_model.overdue_title"
      :subtitle="redModel.overdue_model.overdue_text"
    >
      <template #action>
        <ChipButton
          @click="$redirect(redModel.overdue_model.overdue_button_link, 'push')"
          color="white"
        >
          {{ redModel.overdue_model.overdue_button_text }}
        </ChipButton>
      </template>
    </InfoBanner>
  </div>
  <!-- Repayment Banner -->
  <div v-else-if="redModel.repayment_model" class="info-banner__repayment">
    <ChipButton
      block
      @click="onBannerBtnClick(redModel.repayment_model.repayment_link, 'push')"
    >
      {{ redModel.repayment_model.repayment_text }}
    </ChipButton>
  </div>
</template>

<script>
import InfoBanner from "@/components/shared/banner/InfoBanner";
import ChipButton from "@/components/shared/button/ChipButton.vue";
import { mapActions } from "vuex";

export default {
  components: {
    InfoBanner,
    ChipButton,
  },
  props: {
    redModel: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("system", ["showAlert"]),
    onBannerBtnClick(link) {
      if (this.redModel.repayment_model.alert_model) {
        const { title, text, close_button_text } =
          this.redModel.repayment_model.alert_model;
        this.showAlert({
          title,
          text,
          btnCloseText: close_button_text,
        });
        return;
      }
      this.$redirect(link, "push");
    },
  },
};
</script>

<style lang="scss" scoped>
.info-banner {
  &__repayment {
    padding: 15px 15px 5px;
  }
}
</style>
